class EnvioCertificado {
    constructor(gql, $scope) {
        this.apply = (fun) => $scope.$apply(fun)
        this.gql = gql
    }

    $onInit() {
        this.contrato = this.resolve.contrato
    }

    upload() {
        const query = gql`
            mutation UpdateCertificado($arquivo: Upload!, $senha: String!, $contratoId: Int!) {
                certificado: updateCertificado(arquivo: $arquivo, senha: $senha, empresaId: $contratoId) {
                    id
                }
            }
        `
        const variables = {
            arquivo: this.arquivo,
            senha: this.password,
            contratoId: parseInt(this.contrato.id)
        }

        const uploadProgress = (e) => {
            this.apply(() => this.progress = (e.loaded / e.total) * 100)
        }

        return this.gql
            .mutate(query, variables, {context: {uploadProgress}})
            .then(() => {
                Alert.success(`Certificado para a empresa <b>${this.contrato.razaoSocial}</b> enviado com sucesso!`, 'Sucesso')
                this.apply(() => this.close({$value: {ok: true}}))
            })
            .catch(([{ message }]) => {
                this.error = this.motivoErro(message)
            })
    }

    motivoErro(code) {
        switch(code) {
            case 'expired_certificate':
                return 'O certificado está vencido.'
            case 'cnpj_incorrect':
                return 'A raiz do certificado é incompatível com a raiz da empresa.'
            default:
                return 'O certificado ou a senha estão inválidos.'
        }
    }

    submit(form) {
        if(form.$valid) {
            this.promise = this.upload()
        }
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('envioCertificado', {
        controller: ['gql', '$scope', EnvioCertificado],
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
        <form name="form" ng-submit="$ctrl.submit(form)" novalidate>
            <promise-tracker promise="$ctrl.promise" active="$ctrl.loading">
                <modal modal-title="{{$ctrl.contrato.razaoSocial | limitToDots:40}} - {{$ctrl.contrato.raizCnpj | cpfCnpj}}" close="$ctrl.close">
                    <modal-body>
                        <div class="clearfix">
                            <div class="form-group col-xs-12 col-sm-8">
                                <label>Arquivo</label>
                                <input 
                                    class="btn btn-default btn-block"
                                    ngf-select
                                    type="file"
                                    name="arquivo"
                                    accept=".pfx"
                                    ng-model="$ctrl.arquivo"
                                    required>
                                <div 
                                    ng-messages="form.arquivo.$error" 
                                    ng-messages-multiple 
                                    ng-messages-include="erros-validacao"
                                    ng-if="form.$submitted">
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-sm-4">
                                <label>Senha</label>
                                <input type="password" name="password" ng-model="$ctrl.password" required="required" class="form-control" />
                                <div 
                                    ng-messages="form.password.$error" 
                                    ng-messages-multiple="ng-messages-multiple" 
                                    ng-messages-include="erros-validacao" 
                                    ng-if="form.$submitted">
                                </div>
                            </div>

                            <div class="col-xs-12">
                                <highlighted ng-show="$ctrl.error">
                                    <main>Não foi possível enviar o certificado.</main>
                                    <secondary class="text-danger">
                                        {{ $ctrl.error }}
                                    </secondary>
                                </highlighted>
                            </div>

                            <div class="progress" ng-class="{'progress-striped active': $ctrl.progress == 100}" ng-show="$ctrl.progress > 0">
                                <div class="progress-bar bg-color-blue" role='progressbar' ng-style="{ 'width': $ctrl.progress + '%' }"></div>
                            </div>
                        </div>
                    </modal-body>
                    <modal-footer>
                        <button class="btn btn-primary" type="submit" ng-disabled="$ctrl.loading">Enviar</button>
                        <button class="btn btn-default" type="button" ng-disabled="$ctrl.loading" ng-click="$ctrl.close()">Fechar</button>
                    </modal-footer>
                </modal>
            </promise-tracker>
        </form>
        `
    })
